var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/BasePage/BasePageBody.tsx",
  _this = this;
import React, { useContext } from 'react';
import { SMFooter, SMHeader, MobileBanner, SessionTimeoutModal, CookieBanner, StaticContext, ErrorController } from '../..';
var BasePageBody = function BasePageBody(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    _ref$headerVariant = _ref.headerVariant,
    headerVariant = _ref$headerVariant === void 0 ? 'default' : _ref$headerVariant,
    _ref$footerVariant = _ref.footerVariant,
    footerVariant = _ref$footerVariant === void 0 ? 'default' : _ref$footerVariant,
    errorCtrl = _ref.errorCtrl,
    _ref$showBillingAddre = _ref.showBillingAddress,
    showBillingAddress = _ref$showBillingAddre === void 0 ? false : _ref$showBillingAddre,
    _ref$includeHeader = _ref.includeHeader,
    includeHeader = _ref$includeHeader === void 0 ? true : _ref$includeHeader,
    _ref$includeFooter = _ref.includeFooter,
    includeFooter = _ref$includeFooter === void 0 ? true : _ref$includeFooter,
    _ref$includeMobileIns = _ref.includeMobileInstallBanner,
    includeMobileInstallBanner = _ref$includeMobileIns === void 0 ? true : _ref$includeMobileIns,
    children = _ref.children,
    _ref$actionFlow = _ref.actionFlow,
    actionFlow = _ref$actionFlow === void 0 ? 'header' : _ref$actionFlow,
    _ref$showCreateSurvey = _ref.showCreateSurveyButton,
    showCreateSurveyButton = _ref$showCreateSurvey === void 0 ? true : _ref$showCreateSurvey,
    _ref$sticky = _ref.sticky,
    sticky = _ref$sticky === void 0 ? true : _ref$sticky,
    _ref$isMRX = _ref.isMRX,
    isMRX = _ref$isMRX === void 0 ? false : _ref$isMRX,
    _ref$excludeMenuItems = _ref.excludeMenuItems,
    excludeMenuItems = _ref$excludeMenuItems === void 0 ? [] : _ref$excludeMenuItems,
    _ref$showLoginButton = _ref.showLoginButton,
    showLoginButton = _ref$showLoginButton === void 0 ? true : _ref$showLoginButton,
    _ref$showSignupButton = _ref.showSignupButton,
    showSignupButton = _ref$showSignupButton === void 0 ? true : _ref$showSignupButton,
    _ref$displayLICTA = _ref.displayLICTA,
    displayLICTA = _ref$displayLICTA === void 0 ? true : _ref$displayLICTA,
    _ref$showDrawer = _ref.showDrawer,
    showDrawer = _ref$showDrawer === void 0 ? true : _ref$showDrawer,
    Logo = _ref.Logo,
    wrenchVariant = _ref.wrenchVariant,
    _ref$makeFooterLinksS = _ref.makeFooterLinksStatic,
    makeFooterLinksStatic = _ref$makeFooterLinksS === void 0 ? false : _ref$makeFooterLinksS;
  var _useContext = useContext(StaticContext),
    user = _useContext.user,
    url = _useContext.url,
    environment = _useContext.environment,
    locale = _useContext.locale,
    clientConfig = _useContext['client-config'],
    GDPR = _useContext.GDPR;
  var language = environment.languageCode,
    country = environment.countryCode,
    subdomain = environment.subdomain,
    domain = environment.domain,
    tld = environment.tld;
  return /*#__PURE__*/React.createElement(React.Fragment, null, includeHeader ? /*#__PURE__*/React.createElement(SMHeader, {
    isAnonHeaderSticky: sticky,
    isUserAuthenticated: user.isAuthenticated,
    color: color,
    variant: headerVariant,
    lang: language,
    isEUDC: locale.isEUDC,
    actionFlow: actionFlow,
    user: user,
    showCreateSurveyButton: showCreateSurveyButton,
    isMRX: isMRX,
    excludeMenuItems: excludeMenuItems,
    showLoginButton: showLoginButton,
    showSignupButton: showSignupButton,
    displayLICTA: displayLICTA,
    showDrawer: showDrawer,
    Logo: Logo,
    wrenchVariant: wrenchVariant,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 9
    }
  }) : null, errorCtrl ? /*#__PURE__*/React.createElement(ErrorController, Object.assign({}, errorCtrl, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 9
    }
  }), children) : /*#__PURE__*/React.createElement(React.Fragment, null, children), includeFooter ? /*#__PURE__*/React.createElement(SMFooter, {
    subdomain: subdomain,
    domain: domain,
    lang: language,
    country: country,
    isUserAuthenticated: user.isAuthenticated,
    showBillingAddress: showBillingAddress,
    variant: footerVariant,
    isEUDC: locale.isEUDC,
    tld: tld,
    url: url,
    onetrustBannerEnabled: GDPR.onetrustBannerEnabled,
    makeFooterLinksStatic: makeFooterLinksStatic,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 108,
      columnNumber: 9
    }
  }) : null, user.isAuthenticated ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SessionTimeoutModal, {
    user: user,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 125,
      columnNumber: 11
    }
  }), includeMobileInstallBanner && /*#__PURE__*/React.createElement(MobileBanner, {
    downloadLink: clientConfig.mobileBannerDownloadLink,
    deepLinkData: undefined,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 127,
      columnNumber: 13
    }
  })) : null, !GDPR.onetrustBannerEnabled ? /*#__PURE__*/React.createElement(CookieBanner, {
    GDPR: GDPR,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 134,
      columnNumber: 38
    }
  }) : null);
};
export default BasePageBody;
//# sourceMappingURL=BasePageBody.js.map